export default "__VITE_ASSET__BQ5OhuT2__"